// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ic1-centered[data-v-4c69e557]{display:flex;align-items:center;justify-content:center}.ic1-card-error[data-v-4c69e557]{flex-direction:row;align-items:flex-start;padding:.625rem 1.75rem;position:static;width:-moz-fit-content;width:fit-content;height:-moz-fit-content;height:fit-content;left:0;top:0;background:#fbe7e7;border:1px solid #da100b;box-sizing:border-box;border-radius:5px;flex:none;order:0;align-self:stretch;flex-grow:0;margin:10px 0}", ""]);
// Exports
module.exports = exports;
